import { AppConfigArea } from 'enums';

import { ConfigsPageTab } from '../ConfigsPageTab';

export const PayoutOrdersTab: React.FC = () => (
  <ConfigsPageTab area={AppConfigArea.PayoutOrders} />
);
